<div class="theme-color padding-10" fxLayout="row" fxLayoutAlign="space-between center">
    <span class="icon_color">Tracking Information</span>
    <button class="icon_color" (click)="close()" mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="padding-10" style="height: 750px;overflow: auto;">

    <div class="back">
        <div ngClass.gt-md="border">
            <div class="bdr-b backgray padding-10" fxLayout="row" fxLayoutAlign="space-between center">
                <div class=" padding-5">
                    <span>Tracking Status</span>
                </div>
            </div>
            <h1 style="text-align: center;"><b>{{orderMsgErr}}</b></h1>

            <div class="backg borderb"  *ngFor="let orderInfo of salesFlatShipment">
                <div fxLayout="row">
                    <div fxFlex="50" fxLayout="column" fxLayoutGap="10px" class="padding-10">
                        <div *ngFor="let item of orderInfo.salesFlatShipmentItem">
                            {{item.name}}
                        </div>
                        <div>
                            <span> <b>Qty</b> {{orderInfo.totalQty}}</span>
                        </div>
                    </div>
                   
                </div>
                <!-- <h1 style="text-align: center;" *ngIf="orderMsg"><b>Order Delivered !</b></h1> -->
                <div fxLayout="row" class="padding-10">
                    <calsoft-track style="width: 100%;" [trackValue]="trackValues"
                        [title]="orderInfo.salesFlatShipmentTrack[0].title"
                        [trackNumber]="orderInfo.salesFlatShipmentTrack[0].trackNumber"
                        [carrierCode]="orderInfo.salesFlatShipmentTrack[0].carrierCode"></calsoft-track>
                </div>
            </div>

        <div >
            <div class="map-container">
                <div id="map" class="map" ></div>
            </div>        
            <div *ngIf="trackStatus === 'Ongoing' ">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <div fxFlex="50">
                        <img src="assets/images/origin.png" class="img-text" />
                        <p>Your location</p>
                    </div>
                    <div fxFlex="50">
                        <img src="assets/images/client.png" class="img-text" />
                        <p>Delivery Boy</p>
                    </div>
                </div>    
            </div>

            <div *ngIf="trackStatus === 'Pending' ">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <div fxFlex="50">
                        <img src="assets/images/origin.png" class="img-text" />
                        <p>Delivery Boy</p>
                    </div>
                    <div fxFlex="50">
                        <img src="assets/images/client.png" class="img-text" />
                        <p>Store Location</p>
                    </div>
                </div>    
            </div>

            <div *ngIf="trackStatus === 'Ongoing' ">
            <p> Distance to Reach: {{ distance }} </p>
            <p> Time to Reach: {{ duration }} </p>
            </div>

        </div>
        </div>
    </div>


</div>